import { BaseDto } from "./base.dto";
import { ProductDto } from "./product.dto";

export class ProductNutritionDto extends BaseDto {
    saturatedFat: number;
    transFat: number;
    cholesterol: number;
    carbohydrate: number;
    energy: number;
    sodium: number;
    dietaryFiber: number;
    sugars: number;
    calories: number;
    protein: number;
    product: ProductDto;
  }